import {password, compare } from '@rxweb/reactive-form-validators';

export class RecoverPassModel {
    @password({
        validation: {
            minLength: 8,
            maxLength: 25,
            digit: true,
        //    specialCharacter: true,
            lowerCase: true,
            //upperCase: true
        },
        message: {
            minLength: 'La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.',
            maxLength: 'La contraseña debe tener máximo 25 caracteres.',
            digit: 'La contraseña debe incluir al menos un número.',
        //    specialCharacter: 'La contraseña debe incluir al menos un carácter especial (*#+!%$”?).',
            lowerCase: 'La contraseña debe incluir al menos una letra minúscula.',
            //upperCase: 'La contraseña debe incluir al menos una letra mayúscula.'
        }
    })
    lastpassword: string;
    @password({
        validation: {
            minLength: 8,
            maxLength: 25,
            digit: true,
        //    specialCharacter: true,
            lowerCase: true,
            //upperCase: true
        },
        message: {
            minLength: 'La contraseña debe tener al menos 8 caracteres, incluyendo una minúscula y un número.',
            maxLength: 'La contraseña debe tener máximo 25 caracteres.',
            digit: 'La contraseña debe incluir al menos un número.',
        //    specialCharacter: 'La contraseña debe incluir al menos un carácter especial (*#+!%$”?).',
            lowerCase: 'La contraseña debe incluir al menos una letra minúscula.',
            //upperCase: 'La contraseña debe incluir al menos una letra mayúscula.'
        }
    })
    newpassword: string;


    @compare({ 
        fieldName: 'newpassword',
        message: 'La confirmación de contraseña no coincide con la nueva contraseña.'
    })
    passwordConfirm: string;
}